<script lang="ts">
    import cn from "classnames";
    import { createEventDispatcher } from "svelte";

    import Button from "./Buttons/Button.svelte";

    export let ariaLabel = "";
    export let text = "";
    export let loading = false;
    export let className: string;
    export let variant: "contained" | "outlined" | "text" | "opacityOnHover" =
        "outlined";
    export let size: "small" | "medium" | "large" = "medium";

    export { className as class };

    const dispatch = createEventDispatcher();
    const loadMore = () => {
        dispatch("loadMore");
    };
</script>

<div class="gw-load-more">
    <Button
        {variant}
        {size}
        class={cn("gw-load-more__button", className)}
        {ariaLabel}
        on:click={loadMore}
        {loading}
    >
        {text}
        <slot />
    </Button>
</div>

<style>
    .gw-load-more {
        width: 100%;
        text-align: center;
    }
</style>
